import type { AxiosError, AxiosInstance } from "axios";
import { IContent } from "./interfaces";

export function getContentTypeBuilder(apiClient: AxiosInstance) {
  return async function getContentType(
    slug: string,
  ): Promise<IContent.IContentTypeResponse | null> {
    try {
      const response = await apiClient.post("/content-type/", { slug });
      return response.data;
    } catch (error: unknown) {
      // if the error is a 404, return null
      if ((error as AxiosError).response?.status === 404) {
        return null;
      }
      // else rethrow
      else {
        throw error;
      }
    }
  };
}
